import { render, staticRenderFns } from "./UpsellDetail.vue?vue&type=template&id=0e0e31bc"
import script from "./UpsellDetail.vue?vue&type=script&lang=js"
export * from "./UpsellDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports